<template>
  <div class="section py-0 px-5">
    <div class="tile app-title">
      <p class="subtitle is-6">Par date</p>
    </div>
    <b-datepicker placeholder="Cliquer ici..."
                  icon="calendar-today"
                  class="date-start"
                  v-model="dateStart"
                  :readonly="false"
                  :show-week-number="true"/>
    <b-datepicker placeholder="Cliquer ici..."
                  icon="calendar-today"
                  :min-date="this.dateStart"
                  v-model="dateEnd"
                  :readonly="false"
                  :show-week-number="true"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import * as types from '@/store/creationOpportunite/venteFacesLc-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');
const Panier = createNamespacedHelpers('panier');
export default {
  name: 'date',
  components: {
  },
  data() {
    return {
      valid: false,
    };
  },
  computed: {
    ...VenteFacesLc.mapGetters({
      getAddress: 'address',
      getDateStart: 'dateStart',
      getDateEnd: 'dateEnd',
    }),
    ...Panier.mapGetters({
      panneauxLcPanier: 'panneauxLcPanier',
    }),
    address: {
      get() {
        return this.getAddress;
      },
      set(value) {
        this.setAddress(value);
      },
    },
    dateStart: {
      get() {
        return this.getDateStart;
      },
      set(value) {
        this.setDateStart(value);
        if (value && moment(value).isValid()) {
          const dateEnd = moment(value).add(1, 'y').subtract(1, 'd').toDate();
          this.setDateEnd(dateEnd);
        }
        if (((this.dateStart && this.dateEnd)
         || (!this.dateStart && !this.dateEnd)) && this.address) {
          this.recherchePanneauxLc();
        }
      },
    },
    dateEnd: {
      get() {
        return this.getDateEnd;
      },
      set(value) {
        if (value && this.dateStart && value < this.dateStart) {
          this.setDateStart(value);
        }
        this.setDateEnd(value);
        if (((this.dateStart && this.dateEnd)
        || (!this.dateStart && !this.dateEnd)) && this.address) {
          this.recherchePanneauxLc();
        }
      },
    },
  },
  methods: {
    ...VenteFacesLc.mapMutations({
      setAddress: types.SET_FILTER_ADDRESS,
      setDateStart: types.SET_DATE_START,
      setDateEnd: types.SET_DATE_END,
    }),
    ...VenteFacesLc.mapActions({
      actionsGestionPanneauxLc: 'gestionPanneauxLC',
    }),
    recherchePanneauxLc() {
      this.valid = true;
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionsGestionPanneauxLc({ valid: this.valid,
        panneauxLcPanier: this.panneauxLcPanier,
        codeFace: '',
      }).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la recherche d\'un panneaux LC liée à la date', e);
      });
    },
  },
};
</script>

<style scoped>
  .date-start {
    padding-bottom:5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/filtres/date.vue